module.exports = __webpack_public_path__ + "static/media/catban1.055f1c30.png";